import { render, staticRenderFns } from "./ChangedAllowance.vue?vue&type=template&id=cb9d0c64"
import script from "./ChangedAllowance.vue?vue&type=script&lang=js"
export * from "./ChangedAllowance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports